import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Chapter = ({ num, label, light = false }) => (
    <div
        className="flex items-center gap-4"
        data-testid={`chapter-${num}`}
    >
        <span className="font-mono text-sm font-bold text-brand">
            {String(num).padStart(2, "0")}
        </span>
        <span className="h-px w-10 bg-brand" />
        <span
            className={`font-mono text-xs uppercase tracking-[0.3em] ${
                light ? "text-zinc-400" : "text-zinc-500"
            }`}
        >
            {label}
        </span>
    </div>
);
